import { patientNotesClient } from '@/api/patients/patientNotesClient';
import { QueryKey } from '@/data/query';

interface PatientNotesPageParams {
  size: number;
  after?: string;
  before?: string;
}

const queryClient = patientNotesClient();

export const useGetPatientNotes = (
  pageParams: PatientNotesPageParams,
  search?: string,
  sort?: string,
  patientId?: number,
) => {
  const query: Record<string, any> = { page: pageParams };

  if (search) {
    query.search = search;
  }

  if (sort) {
    query.sort = sort;
  }

  const queryResult = queryClient.listPatientNotes.useQuery({
    queryKey: [QueryKey.GetPatientNotes, pageParams, search, sort, patientId],
    queryData: {
      params: { id: Number(patientId) },
      query,
    },
    enabled: Boolean(patientId),
  });
  return {
    data: queryResult.data?.body ?? null,
    isError: queryResult.isError,
    isLoading: queryResult.isLoading,
    refetch: queryResult.refetch,
  };
};
